/// <reference path="./global.d.ts" />

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

/** ANGULARJS */
import './decorators';
import './ib-web-ancillaries-app-module';
import './ib-web-ancillaries-constants';
import './app/core';
import './app/shared';
import './app/features';

/** ANGULAR **/
export * from './ib-ancillaries-app.module';
export * from './app/features/components/ib-booking-switch-sell/ib-booking-switch-sell.module';
export * from './app/features/components/ib-booking-switch-sell/ib-booking-switch-sell.component';

/** DEPENDENCIES LEGACY */
import jQuery from 'jquery';
declare global {
    interface Window {
        $: any;
        RecoglobickActivitiesWidget: any;
        RecoglobickTransfersWidget: any;
    }
}
window.RecoglobickActivitiesWidget;
window.RecoglobickTransfersWidget;
// FIxes an error with ibdc in local
window.$ = jQuery;